<template>
  <v-dialog v-model="showDialog" class="text-center" max-width="600">
    <v-card>
      <v-card-title class="headline justify-center">Всем авторам!</v-card-title>

      <v-card-text class="text-center">
        В вашем Партнерском кабинете появилась ваша личная партнерская ссылка.
        Приглашая читателей по ней, вы получите 10% сверху за каждую купленную
        читателем книгу у вас или ваших коллег.
      </v-card-text>
      <v-card-actions class="justify-space-around">
        <v-btn :to="{ name: 'PartnerIndex' }" color="green darken-1" text
          >Перейти</v-btn
        >

        <v-btn color="red darken-1" text @click="close">Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
    <script>
import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["home"],
  data: () => ({
    showDialog: false,
  }),
  methods: {
    close() {
      this.showDialog = false;
    },
    open() {
      console.log('open')
      this.showDialog = true;
      if (this.home) {
        localStorage.setItem("show_partner_dialog_at_home", true);
      }
    },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      loadPage: "loadPage",
      siteSettings: "siteSettings",
    }),
    isAuthor() {
      if (this.currentUser && this.currentUser.author) {
        return true;
      }
      return false;
    },
  },
  watch: {
    currentUser() {
      if (this.isAuthor && this.home) {
        let showed = true; //Сообщение показывалось
        showed =
          JSON.parse(localStorage.getItem("show_partner_dialog_at_home")) ===
          true;

        // console.log("showed", showed);

        if (!showed) {
          this.open();
        }
      }
    },
  },
  mounted() {},
};
</script>